import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { isEmailVerified } from '@/shared/utils/emailVerified';
import {
    INSTITUTIONS,
    INSTITUTION_KEYS,
} from '@/shared/constants/institutions';
import usePageTitle from '@/shared/hooks/usePageTitle';
import { INSTITUTION_LOGOS } from '@/shared/constants/institutionLogos';
import './HomePage.css';

const STEPS = [
    {
        title: 'Post what you no longer need',
        body: 'Desks, chairs, shelving, lab equipment. Add photos and where it is. Listings run for 30 days.',
    },
    {
        title: 'Claim what you can use',
        body: 'Browse every department on the Auraria Campus, request an item, and arrange the handoff with the poster.',
    },
    {
        title: 'Keep it on campus',
        body: 'Department-to-department transfer is the fastest route in every institution’s policy, and it keeps furniture out of the landfill.',
    },
];

function HomePage() {
    usePageTitle();
    const { currentUser } = useAuth();
    // The same rule the nav applies, and it has to stay the same rule. This
    // page sends people to /listings, which is behind the verified-account
    // guard, so branching on currentUser alone would offer an unverified user
    // a route that rejects them.
    const signedIn = currentUser && isEmailVerified(currentUser);
    return (
        <>
            <section className="afe-hero">
                <Container className="py-5">
                    <Row className="justify-content-center text-center">
                        <Col lg={10}>
                            <h1 className="display-5">
                                Furniture and equipment reuse across the Auraria
                                Campus
                            </h1>
                            <p className="lead mb-4">
                                One exchange for faculty and staff of all four
                                campus institutions.
                            </p>
                            {signedIn ? (
                                <Button
                                    as={Link}
                                    to="/listings"
                                    size="lg"
                                    variant="light"
                                >
                                    Browse listings
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        as={Link}
                                        to="/signup"
                                        size="lg"
                                        variant="light"
                                        className="me-2"
                                    >
                                        Sign up with your campus email
                                    </Button>
                                    <Button
                                        as={Link}
                                        to="/login"
                                        size="lg"
                                        variant="outline-light"
                                    >
                                        Log in
                                    </Button>
                                </>
                            )}
                        </Col>
                    </Row>
                    <ul
                        className="afe-hero-logos list-unstyled mb-0"
                        aria-label="Participating institutions"
                    >
                        {INSTITUTION_KEYS.map((key) => (
                            <li key={key}>
                                <img
                                    src={INSTITUTION_LOGOS.dark[key]}
                                    alt={INSTITUTIONS[key].name}
                                    className={`afe-hero-logo afe-hero-logo-${key}`}
                                />
                            </li>
                        ))}
                    </ul>
                </Container>
            </section>
            <Container className="py-5">
                <Row>
                    {STEPS.map((step) => (
                        <Col md={4} key={step.title} className="mb-3">
                            <Card className="h-100 afe-step">
                                <Card.Body>
                                    <Card.Title as="h2" className="h5">
                                        {step.title}
                                    </Card.Title>
                                    <Card.Text>{step.body}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    );
}

export default HomePage;
